<div class="btn-group nav-item dropdown">
  <button id="button-animated" type="button"
          class="btn btn-primary dropdown-toggle"
          aria-controls="dropdown-animated"
          (click)="isCollapsed = !isCollapsed">
    <app-person-icon [size]="3"></app-person-icon>
    <span class="caret"></span>
  </button>

  <ul id="dropdown-animated"
      class="dropdown-menu dropdown-menu-end"
      role="menu"
      aria-labelledby="button-animated"
      [attr.aria-expanded]="!isCollapsed"
      [ngClass]="{'d-none': isCollapsed, 'd-block show in': !isCollapsed}">
    <li role="menuitem">
      <app-username class="dropdown-header"></app-username>
    </li>
    <li class="dropdown-divider">
    </li>
    <li role="menuitem">
      <a class="dropdown-item" [routerLink]="[]" (click)="logout()" id="menu-logout-link">Logout</a>
    </li>
  </ul>
</div>
